const getBackendOrigin = () => {
  const envURL = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL;
  if (envURL) {
    return String(envURL).replace(/\/$/, '').replace(/\/api$/, '');
  }
  const locationObj =
    typeof window !== 'undefined' ? window.location : { hostname: 'localhost', protocol: 'http:' };
  const host = locationObj.hostname;
  const protocol = locationObj.protocol === 'https:' ? 'https' : 'http';
  const isLocalhost = host === 'localhost' || host === '127.0.0.1';
  if (isLocalhost) return 'http://localhost:5000';
  return `${protocol}://${host}:5000`;
};

export const resolveMediaUrl = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) {
    return raw;
  }
  const normalizedPath = raw.startsWith('/') ? raw : `/${raw}`;
  return `${getBackendOrigin()}${normalizedPath}`;
};

